import { LoggedUser } from './LoggedUser'
import { Language } from '../../../i18n'

export interface LoggedUserDTO {
  id: string
  name: string
  email: string
  gender: number
  birthDate: string
  dni: string
  settings: string
  sessionExpires: string
  roles: string[]
  permissions: string[]
  language: Language
}

export function toModel(d: LoggedUserDTO): LoggedUser {
  return new LoggedUser({
    id: d.id,
    name: d.name || d.email,
    email: d.email,
    gender: d.gender,
    birthDate: new Date(d.birthDate),
    dni: d.dni,
    settings: d.settings,
    sessionExpires: new Date(d.sessionExpires),
    roles: d.roles,
    permissions: d.permissions,
    language: d.language,
  })
}

export function fromModel(m: LoggedUser): LoggedUserDTO {
  return {
    id: m.id,
    name: m.name,
    email: m.email,
    gender: m.gender,
    birthDate: m.birthDate.toISOString(),
    dni: m.dni,
    settings: m.settings,
    sessionExpires: m.sessionExpires.toISOString(),
    roles: m.roles,
    permissions: m.permissions,
    language: m.language,
  }
}
